<template lang="pug">
.account-update-form
  v-form(ref="form")
    v-container
      v-layout
        v-flex
          v-text-field(
            :value="user.displayName"
            label="會員姓名"
            disabled)
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            v-model="account"
            :counter="40"
            :error-messages="accountErrors"
            label="帳號(電子信箱)"
            outline
            @input="$v.account.$touch()"
            @blur="$v.account.$touch()")
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, sameAs, email } from "vuelidate/lib/validators";
import formBuilder from "@/utils/formBuilder";

export default {
  name: "AccountUpdateForm",
  mixins: [validationMixin],
  validations: {
    account: { required, email }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      account: this.user.account
    };
  },
  computed: {
    accountErrors() {
      const errors = [];
      if (!this.$v.account.$dirty) return errors;
      !this.$v.account.required && errors.push("請輸入帳號");
      !this.$v.account.email && errors.push("請輸入電子信箱格式");
      return errors;
    }
  },
  methods: {
    ...mapActions(["api"]),
    reset() {
      this.$refs.form.reset();
      this.$v.$reset();
    },
    getFormData() {
      return formBuilder(["account"], this);
    },
    async submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      }

      return await this.api({
        method: "post",
        url: `auth/${this.user.uid}`,
        data: this.getFormData()
      });
    }
  }
};
</script>
